import React from "react";
import { Link } from "react-router-dom";

export default function Privacy() {
  return (
    <div className="min-h-screen bg-black text-white">
      <div className="h-1 w-full bg-orange-500" />

      <div className="mx-auto max-w-4xl px-6 py-12">
        <div className="mb-8">
          <p className="text-sm text-white/70">Legal</p>
          <h1 className="mt-2 text-3xl font-extrabold tracking-tight">
            Privacy Policy
          </h1>
          <p className="mt-2 text-white/70">
            Last updated: <span className="text-white">2026-02-02</span>
          </p>
        </div>

        <div className="rounded-2xl border border-white/10 bg-black/5 p-6 shadow-xl">
          <h2 className="text-lg font-semibold">Information we collect</h2>
          <p className="mt-2 text-white/80 leading-relaxed">
            When you request a quote or contact BuildBright, we may collect
            information you provide such as your name, email, phone number, ZIP
            code, project/service details, and optional photos.
          </p>
          <p className="mt-2 text-white/80 leading-relaxed">
            If you are a contractor, we may collect business and account
            information you provide such as company name, contact details,
            service categories, and service-area ZIP codes.
          </p>

          <div className="my-6 h-px w-full bg-black/10" />

          <h2 className="text-lg font-semibold">How we use information</h2>
          <ul className="mt-3 list-disc pl-5 space-y-2 text-white/80">
            <li>Match you with contractors and help you receive quotes</li>
            <li>Communicate with you about your request</li>
            <li>Operate, maintain, secure, and improve the platform</li>
            <li>Prevent fraud and abuse</li>
          </ul>

          <div className="my-6 h-px w-full bg-black/10" />

          <h2 className="text-lg font-semibold">Sharing of information</h2>
          <p className="mt-2 text-white/80 leading-relaxed">
            We may share your request details with independent contractors so
            they can contact you with quotes or service information.
          </p>
          <p className="mt-2 text-white/80 leading-relaxed">
            We may also share information with service providers that help us
            operate BuildBright (for example, payments processing, messaging,
            email delivery, and hosting). These providers process data on our
            behalf.
          </p>
          <p className="mt-2 text-white/80 leading-relaxed">
            We do not sell your personal information to third-party marketers.
          </p>

          <div className="my-6 h-px w-full bg-black/10" />

          <h2 className="text-lg font-semibold">SMS messaging</h2>
          <p className="mt-2 text-white/80 leading-relaxed">
            If you opt in to SMS, we may send you updates related to your
            request. Message frequency varies. Standard message &amp; data rates
            may apply.
          </p>
          <p className="mt-2 text-white/80 leading-relaxed">
            You can opt out at any time by replying <strong>STOP</strong>. For
            help, reply <strong>HELP</strong>. Consent is not a condition of
            purchase.
          </p>

          <div className="my-6 h-px w-full bg-black/10" />

          <h2 className="text-lg font-semibold">Cookies and analytics</h2>
          <p className="mt-2 text-white/80 leading-relaxed">
            We may use cookies or similar technologies to keep the site working,
            remember preferences, and understand how the site is used. You can
            control cookies through your browser settings.
          </p>

          <div className="my-6 h-px w-full bg-black/10" />

          <h2 className="text-lg font-semibold">Data retention</h2>
          <p className="mt-2 text-white/80 leading-relaxed">
            We keep information as long as needed to operate the platform,
            comply with legal obligations, resolve disputes, and enforce our
            agreements. We may retain some information longer where required or
            permitted by law.
          </p>

          <div className="my-6 h-px w-full bg-black/10" />

          <h2 className="text-lg font-semibold">Your choices and rights</h2>
          <p className="mt-2 text-white/80 leading-relaxed">
            You may request access, correction, or deletion of your information
            by contacting us. If you are a California resident, you may have
            additional rights. BuildBright does not sell personal information.
          </p>

          <div className="my-6 h-px w-full bg-black/10" />

          <h2 className="text-lg font-semibold">Security</h2>
          <p className="mt-2 text-white/80 leading-relaxed">
            We take reasonable measures to protect information, but no system is
            100% secure.
          </p>

          <div className="my-6 h-px w-full bg-black/10" />

          <h2 className="text-lg font-semibold">Contact</h2>
          <p className="mt-2 text-white/80 leading-relaxed">
            Email:{" "}
            <span className="text-orange-400 font-semibold">
              support@buildbright.app
            </span>
          </p>

          <div className="my-6 h-px w-full bg-black/10" />

          <p className="text-xs text-white/50">
            This Privacy Policy is provided for general informational purposes.
            Laws vary by jurisdiction. Consider consulting a licensed attorney.
          </p>

          <div className="mt-6 flex flex-col sm:flex-row gap-3">
            <Link
              to="/terms"
              className="inline-flex items-center justify-center rounded-full border border-white/15 bg-black/5 px-5 py-2 text-sm font-semibold text-white hover:bg-black/10"
            >
              View Terms of Use
            </Link>

            <Link
              to="/"
              className="inline-flex items-center justify-center rounded-full bg-orange-600 px-5 py-2 text-sm font-semibold text-white hover:bg-orange-700"
            >
              Back to Home
            </Link>
          </div>
        </div>

        <p className="mt-8 text-xs text-white/50">
          © {new Date().getFullYear()} BuildBright. All rights reserved.
        </p>
      </div>
    </div>
  );
}
